export interface KofiDonationEvent {
  type: 'kofi_donation';
  source: 'kofi';
  from: string;
  amount: string;
  currency: string;
  message: string | null;
  timestamp: string;
  receivedAt: number;
}

export interface KofiSubscriptionEvent {
  type: 'kofi_subscription';
  source: 'kofi';
  from: string;
  amount: string;
  currency: string;
  message: string | null;
  timestamp: string;
  receivedAt: number;
}

export function isKofiEvent(value: unknown): value is KofiDonationEvent | KofiSubscriptionEvent {
  if (!value || typeof value !== 'object') return false;
  const v = value as { type?: string; source?: string };
  return v.source === 'kofi' && (v.type === 'kofi_donation' || v.type === 'kofi_subscription');
}
